/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgFlagToggleResponse
 */
export interface OrgFlagToggleResponse {
    /**
     * 
     * @type {string}
     * @memberof OrgFlagToggleResponse
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgFlagToggleResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgFlagToggleResponse
     */
    isGlobal: boolean;
}

/**
 * Check if a given object implements the OrgFlagToggleResponse interface.
 */
export function instanceOfOrgFlagToggleResponse(value: object): value is OrgFlagToggleResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('isGlobal' in value) || value['isGlobal'] === undefined) return false;
    return true;
}

export function OrgFlagToggleResponseFromJSON(json: any): OrgFlagToggleResponse {
    return OrgFlagToggleResponseFromJSONTyped(json, false);
}

export function OrgFlagToggleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgFlagToggleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'enabled': json['enabled'],
        'isGlobal': json['isGlobal'],
    };
}

  export function OrgFlagToggleResponseToJSON(json: any): OrgFlagToggleResponse {
      return OrgFlagToggleResponseToJSONTyped(json, false);
  }

  export function OrgFlagToggleResponseToJSONTyped(value?: OrgFlagToggleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'enabled': value['enabled'],
        'isGlobal': value['isGlobal'],
    };
}

